import { useQuery } from '@tanstack/react-query';
import {
  MemberPermissions,
  OperationType,
  QueryMemberNameQuery,
  QueryMemberNameQueryVariables,
} from '__generated__/graphql';
import { MEMBER_NAME_QUERY } from 'apollo/queries/member-queries';
import useGraphQLPaging from 'hooks/graphql/useGraphQLPaging/useGraphQLPaging';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';
import { isEmpty, isNil } from 'lodash';

export default function useCheckCanMangeTimeOffForMembers(memberIds?: string[] | null) {
  const graphqlPaging = useGraphQLPaging();
  const baseQueryKey = useReactQueryBaseKey();
  const { data } = useQuery({
    queryKey: [...baseQueryKey, 'useCheckCanManageTimeOffForMembers', memberIds],
    queryFn: async () => {
      if (!isNil(memberIds) && !isEmpty(memberIds)) {
        const results = await graphqlPaging<QueryMemberNameQuery, QueryMemberNameQueryVariables>(
          {
            document: MEMBER_NAME_QUERY,
            variables: {
              filter: {
                id: { contains: memberIds },
                permissions: {
                  permissions: [MemberPermissions.ManageTimeOff],
                  operationType: OperationType.And,
                },
              },
            },
          },
          'members'
        );

        return results.length === memberIds.length;
      }

      return true;
    },
    enabled: !isNil(memberIds) && !isEmpty(memberIds),
  });

  return data;
}
